export default function FormFieldRadio (props) {
  return (
    <label
      className="wp-block-gds-lead-form__form-field wp-block-gds-lead-form__form-field--radio"
    >
      <input
        type="radio"
        name={props.name}
        checked={props.checked}
        onChange={props.onChange}
      />
      <span className="wp-block-gds-lead-form__form-field--radio-label">
        {props.label}{props.required ? '*' : ''}
      </span>
      {props.description && (
        <p>
          {props.description}
        </p>
      )}
    </label>
  )
}
